import Vue from 'vue'

import Cookies from 'js-cookie'

import Web3 from 'web3'
try {
  window.web3 = new Web3(window.ethereum)
} catch (e) {
  // Ignore bootstrap errors until the user connects a wallet.
}

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'

import '@/assets/styles/index.scss' // global css
import App from './App'
import { getAbi } from '@/api/file'
import BigNumber from '@/components/BigNumber'
import Account from '@/components/Account'

import '@/utils/lib-flexible/flexible.js'

import _BigNumber from 'bignumber.js'
Vue.prototype.BigNumber = _BigNumber

Vue.prototype.getAbi = getAbi

Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'success' })
}
Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: 'error' })
}

Vue.prototype.msgInfo = function(msg) {
  this.$message.info(msg)
}

// Global component mount
Vue.component('BigNumber', BigNumber)
Vue.component('Account', Account)

Vue.use(Element, {
  locale,
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  render: h => h(App)
})
